import type { ExtractPayload } from '@ardoq/rxbeach';
import type { updateViewProperties } from '@ardoq/view-settings';
import { shallowEqual } from 'utils/objectUtils';

type ViewPropertiesPayload = ExtractPayload<typeof updateViewProperties>;

/**
 * Whether two `updateViewProperties` payloads are the same: the same view,
 * and each of its properties the same value. Views send whole view models,
 * which can be large and point back at themselves, so they are never compared
 * deeply.
 */
export const isSameViewProperties = (
  a: ViewPropertiesPayload,
  b: ViewPropertiesPayload
): boolean =>
  a.viewId === b.viewId && shallowEqual(a.viewProperties, b.viewProperties);
